import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const PAGE_GROUP_CHANGED = 'PAGE_GROUP_CHANGED';

export const PAGE_GROUPS = {
  BOOKING_PANEL: 'booking-panel',
  BOOKING_PANEL_ACORN: 'booking-panel-acorn',
  COMBINED_ENTRY_PAGE: 'combined-entry-page',
  COMBINED_EXPLORE: 'combined-explore',
  COMBINED_RESULTS: 'combined-results',
  DAY_VIEW: 'day-view',
  EXPLORE_AI: 'explore-ai',
  HOME: 'home',
  SEARCH_WITH_AI: 'search-with-ai',
  NO_PAGE_TYPE_PROVIDED: 'no-page-type-provided',
  UNKNOWN_PAGE_GROUP: 'unknown-page-group',
} as const;

export type PageGroup = Values<typeof PAGE_GROUPS> | `unrecognised-page-type_${string}`;
